import { render, staticRenderFns } from "./look.vue?vue&type=template&id=5a964935&scoped=true"
import script from "./look.vue?vue&type=script&lang=js"
export * from "./look.vue?vue&type=script&lang=js"
import style0 from "./look.vue?vue&type=style&index=0&id=5a964935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a964935",
  null
  
)

export default component.exports